import { render } from "./ViewUserPage.vue?vue&type=template&id=4294444d&ts=true"
import script from "./ViewUserPage.vue?vue&type=script&lang=ts"
export * from "./ViewUserPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__